import React from "react";
import { classNames } from "../../helpers";
import { useSelector } from "react-redux";
import { loadingState } from "../../redux/reducers/loadingReducer";
import { useTranslation } from "react-i18next";

export default function TwButton(props) {
  const { t, i18n } = useTranslation();
  const loadingReduxState = useSelector(loadingState);
  const { children, type = "button", title = "", className = "", variant = "primary", size = "normal", actionLoading = false } = props
  let variantColor = "text-gray-900 bg-white ring-1 ring-gray-300 ring-inset hover:bg-gray-50 disabled:bg-gray-300 "
  let loadingColor = "text-primary"
  if (variant === "primary") {
    variantColor = "text-white bg-primary disabled:bg-gray-300 hover:bg-light-primary focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary"
    loadingColor = "text-white"
  } else if (variant === "primary-outline") {
    variantColor = "text-primary disabled:text-white hover:text-white bg-white ring-1 ring-primary ring-inset disabled:bg-gray-300 hover:bg-primary"
    loadingColor = "text-white"
  } else if (variant === "secondary") {
    variantColor = "text-white bg-secondary disabled:bg-gray-300 hover:bg-light-secondary focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-secondary"
    loadingColor = "text-white"
  } else if (variant === "secondary-outline") {
    variantColor = "text-secondary disabled:text-white hover:text-white bg-white ring-1 ring-secondary ring-inset disabled:bg-light-secondary hover:bg-secondary"
    loadingColor = "text-secondary"
  } else if (variant === "danger") {
    variantColor = "text-white bg-danger disabled:bg-gray-300 hover:bg-light-danger focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-danger"
    loadingColor = "text-white"
  } else if (variant === "danger-outline") {
    variantColor = "text-danger disabled:text-white hover:text-white bg-white ring-1 ring-danger ring-inset disabled:bg-light-danger hover:bg-danger"
    loadingColor = "text-danger"
  } else if (variant === "default-box") {
    variantColor = "text-gray-900 ring-0 ring-gray-300 ring-inset bg-gray-50 hover:bg-gray-200 disabled:bg-gray-300 "
  }else if (variant === "default-small") {
    variantColor = "!rounded w-max bg-white !px-2 !py-1 md:!px-2 md:!py-1 xl:!px-2 xl:!py-1 !text-xs  text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 disabled:bg-gray-300 !shadow-none"
  }

  return (
    <button
      type={type}
      className={classNames("inline-flex items-center justify-center rounded-2xl px-3.5 py-2.5 md:px-3.5 md:py-2.5 xl:px-4 xl:py-3 text-sm text-center font-semibold  shadow-xs", 
        variantColor, 
        className)}
      onClick={props?.onClick ? props.onClick : () => { }}
      disabled={(loadingReduxState.actionLoading !== undefined && loadingReduxState.actionLoading) || props?.disabled || false}
    >
      {/* {(loadingReduxState?.actionLoading && loadingReduxState.actionLoading === true) ? */}
      {(actionLoading === true) ?
        (<div className="flex justify-center items-center gap-2">
          <svg className="text-gray-300 animate-spin" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"
            width="24" height="24">
            <path
              d="M32 3C35.8083 3 39.5794 3.75011 43.0978 5.20749C46.6163 6.66488 49.8132 8.80101 52.5061 11.4939C55.199 14.1868 57.3351 17.3837 58.7925 20.9022C60.2499 24.4206 61 28.1917 61 32C61 35.8083 60.2499 39.5794 58.7925 43.0978C57.3351 46.6163 55.199 49.8132 52.5061 52.5061C49.8132 55.199 46.6163 57.3351 43.0978 58.7925C39.5794 60.2499 35.8083 61 32 61C28.1917 61 24.4206 60.2499 20.9022 58.7925C17.3837 57.3351 14.1868 55.199 11.4939 52.5061C8.801 49.8132 6.66487 46.6163 5.20749 43.0978C3.7501 39.5794 3 35.8083 3 32C3 28.1917 3.75011 24.4206 5.2075 20.9022C6.66489 17.3837 8.80101 14.1868 11.4939 11.4939C14.1868 8.80099 17.3838 6.66487 20.9022 5.20749C24.4206 3.7501 28.1917 3 32 3L32 3Z"
              stroke="currentColor" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round"></path>
            <path
              d="M32 3C36.5778 3 41.0906 4.08374 45.1692 6.16256C49.2477 8.24138 52.7762 11.2562 55.466 14.9605C58.1558 18.6647 59.9304 22.9531 60.6448 27.4748C61.3591 31.9965 60.9928 36.6232 59.5759 40.9762"
              stroke="currentColor" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round" className={loadingColor}>
            </path>
          </svg>{t("inputFieldsTitle.processing")}
        </div>) : children}
    </button>
  );
}
